export const RESET = 'EXCMCASETYPE_LIST_RESET'
export const SET_ITEMS = 'EXCMCASETYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMCASETYPE_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMCASETYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMCASETYPE_LIST_TOGGLE_LOADING'
